import { Routes } from '@angular/router';
import { provideTranslocoScope } from '@jsverse/transloco';
import { RedeAdsEnum } from './shared/enum/rede-ads.enum';
import { CadastroComponent } from './core/auth/cadastro/cadastro.component';
import { MainContainerV2Component } from './modules/v2/main-container-v2/main-container-v2.component';
import { LoginGuard } from './shared/guards/login/login.guard';
import { NavigationService } from './shared/services/navigation.service';
import { RecuperarSenhaComponent } from './core/auth/recuperar-senha/recuperar-senha.component';
import { ListagemVendaGuard } from './shared/guards/vendas/listagem-venda.guard';
import { ProjetoIdRequiredGuard } from './shared/guards/ratoeiras/projeto-id-required.guard';
import { limitsFeatureGuard } from './shared/guards/limits-feature/limits-feature.guard';
import { fontesTrafegoGuard } from './shared/guards/fontes-trafego/fontes-trafego.guard';
import { projetoHomeGuard, ratoeiraAccessGuard } from './shared/guards/ratoeira/ratoeira-access.guard';
import { minimumPlanBlockedGuard } from './shared/guards/plan/minimum-plan.guard';
import { whatsappModuleGuard } from './shared/guards/whatsapp/whatsapp-module.guard';
import { staffSessionGuard } from './shared/guards/staff-session/staff-session.guard';
import { LogsBackupType } from './modules/logs-backup/models/logs-backup.enum';
import { FeatureEnum } from './shared/enum/feature.enum';
import { RedeAdsAtivaGuard, RedeAdsQueryParamAtivaGuard } from './shared/guards/rede-ads/rede-ads-ativa.guard';
import { managementAdsTranslocoResolver } from './modules/management-ads/resolvers/management-ads-transloco.resolver';
export const APP_ROUTES: Routes = [
    { path: 'cadastro', component: CadastroComponent, providers: [...provideTranslocoScope('auth')] },
    { path: 'esqueci-senha', component: RecuperarSenhaComponent, providers: [...provideTranslocoScope('auth')] },

    // Nova estrutura V2
    {
        path: 'v2',
        providers: [NavigationService, ...provideTranslocoScope('menu'), ...provideTranslocoScope('shared')],
        component: MainContainerV2Component,
        canActivate: [LoginGuard],
        children: [
            {
                path: '',
                redirectTo: 'painel',
                pathMatch: 'full',
            },
            // Seção Analytics
            {
                path: 'painel',
                providers: [...provideTranslocoScope('dashboard')],
                loadComponent: () =>
                    import('./modules/dashboard/dashboard/dashboard.component').then((m) => m.DashboardComponent),
            },
            {
                path: 'dados-assinatura',
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('assinatura')],
                loadComponent: () =>
                    import('./modules/assinatura/subscription-data-page/subscription-data-page.component').then(
                        (m) => m.SubscriptionDataPageComponent,
                    ),
            },
            {
                path: 'release-notes',
                loadComponent: () =>
                    import('./modules/dashboard/components/release-notes-list/release-notes-list.component').then(
                        (m) => m.ReleaseNotesListComponent,
                    ),
            },
            {
                path: 'analytics',
                children: [
                    {
                        path: 'financial-dashboard',
                        providers: [...provideTranslocoScope('financialDashboard')],
                        loadComponent: () =>
                            import('./modules/analytics/financial-dashboard/main-dashboard.component').then(
                                (m) => m.MainDashboardComponent,
                            ),
                    },
                    {
                        path: 'financial-dashboard-new',
                        providers: [...provideTranslocoScope('financialDashboard')],
                        loadComponent: () =>
                            import(
                                './modules/analytics/financial-dashboard-new/dashboard-financeiro-test.component'
                            ).then((m) => m.FinancialDashboardTestComponent),
                    },
                    {
                        path: 'management-ads/meta-ads',
                        canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                        data: {
                            network: RedeAdsEnum.META_ADS,
                        },
                        providers: [...provideTranslocoScope('managementAds')],
                        resolve: { managementAdsI18n: managementAdsTranslocoResolver },
                        loadComponent: () =>
                            import(
                                './modules/management-ads/pages/management-ads-page/management-ads-page.component'
                            ).then((m) => m.ManagementAdsPageComponent),
                    },
                    {
                        path: 'management-ads/google-ads',
                        canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                        data: {
                            network: RedeAdsEnum.GOOGLE_ADS,
                        },
                        providers: [...provideTranslocoScope('managementAds')],
                        resolve: { managementAdsI18n: managementAdsTranslocoResolver },
                        loadComponent: () =>
                            import(
                                './modules/management-ads/pages/management-ads-page/management-ads-page.component'
                            ).then((m) => m.ManagementAdsPageComponent),
                    },
                    {
                        path: 'management-ads/newsbreak-ads',
                        canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                        data: {
                            network: RedeAdsEnum.NEWSBREAK,
                        },
                        providers: [...provideTranslocoScope('managementAds')],
                        resolve: { managementAdsI18n: managementAdsTranslocoResolver },
                        loadComponent: () =>
                            import(
                                './modules/management-ads/pages/management-ads-page/management-ads-page.component'
                            ).then((m) => m.ManagementAdsPageComponent),
                    },
                    {
                        path: 'management-ads/taboola-ads',
                        canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                        data: {
                            network: RedeAdsEnum.TABOOLA,
                        },
                        providers: [...provideTranslocoScope('managementAds')],
                        resolve: { managementAdsI18n: managementAdsTranslocoResolver },
                        loadComponent: () =>
                            import(
                                './modules/management-ads/pages/management-ads-page/management-ads-page.component'
                            ).then((m) => m.ManagementAdsPageComponent),
                    },
                    {
                        path: 'forbidden',
                        providers: [...provideTranslocoScope('planForbidden')],
                        loadComponent: () =>
                            import('./modules/v2/dashboard/dashboard-forbidden/dashboard-forbidden.component').then(
                                (m) => m.DashboardForbiddenComponent,
                            ),
                    },
                    {
                        path: 'logs-campanhas',
                        providers: [...provideTranslocoScope('dashboard'), ...provideTranslocoScope('shared')],
                        loadComponent: () =>
                            import('./modules/v2/integracoes/campanhas-google/campanhas-google-list.component').then(
                                (m) => m.CampanhasGoogleListComponent,
                            ),
                    },
                    {
                        path: 'campanhas-google/historico/:campanhaId',
                        providers: [...provideTranslocoScope('dashboard'), ...provideTranslocoScope('shared')],
                        loadComponent: () =>
                            import('./modules/v2/dashboard/historico-campanhas-por-dia/list/list.component').then(
                                (m) => m.HistoricoCampanhasPorDiaListComponent,
                            ),
                    },
                ],
            },
            // Central de Projetos
            {
                path: 'projetos',
                data: { hasBreadcrumbs: true },
                children: [
                    {
                        path: '',
                        providers: [...provideTranslocoScope('projetos'), ...provideTranslocoScope('limits')],
                        loadComponent: () =>
                            import('./modules/v2/projeto/projeto-list/projeto-list.component').then(
                                (m) => m.ProjetoListComponent,
                            ),
                    },
                    {
                        path: ':projetoId',
                        providers: [
                            ...provideTranslocoScope('mainProjects'),
                            ...provideTranslocoScope('shieldClick'),
                            ...provideTranslocoScope('limits'),
                            ...provideTranslocoScope('shared'),
                        ],
                        loadComponent: () =>
                            import('./modules/v2/main-projects/main-projects.component').then(
                                (m) => m.MainProjectsComponent,
                            ),
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                canActivate: [projetoHomeGuard],
                                children: [],
                            },
                            {
                                path: 'ratoeiras',
                                canActivate: [ratoeiraAccessGuard],
                                children: [
                                    {
                                        path: '',
                                        providers: [
                                            ...provideTranslocoScope('shieldClick'),
                                            ...provideTranslocoScope('limits'),
                                        ],
                                        loadComponent: () =>
                                            import(
                                                './modules/shield-click/shield-click-list/shield-click-list.component'
                                            ).then((m) => m.ShieldClickListComponent),
                                    },
                                    {
                                        path: 'adicionar',
                                        canActivate: [
                                            ProjetoIdRequiredGuard,
                                            limitsFeatureGuard(FeatureEnum.SHIELD_CONFIGURATION),
                                        ],
                                        providers: [...provideTranslocoScope('limits')],
                                        loadComponent: () =>
                                            import(
                                                './modules/shield-click/shield-click-form/shield-click-form.component'
                                            ).then((m) => m.ShieldClickFormComponent),
                                    },
                                    {
                                        path: ':id/editar',
                                        canActivate: [ProjetoIdRequiredGuard],
                                        providers: [...provideTranslocoScope('limits')],
                                        loadComponent: () =>
                                            import(
                                                './modules/shield-click/shield-click-form/shield-click-form.component'
                                            ).then((m) => m.ShieldClickFormComponent),
                                    },
                                    {
                                        path: ':shieldId/:id/visitas',
                                        providers: [...provideTranslocoScope('linkVisitaAcesso')],
                                        loadComponent: () =>
                                            import(
                                                './modules/link-visita-acesso/link-visita-acesso-list/link-visita-acesso-list.component'
                                            ).then((m) => m.LinkVisitaAcessoListComponent),
                                    },
                                ],
                            },
                            {
                                path: 'url-venda',
                                loadComponent: () =>
                                    import(
                                        './modules/v2/gerador-url-venda/gerador-url-venda-list/gerador-url-venda-list.component'
                                    ).then((m) => m.GeradorUrlVendaListComponent),
                            },
                            {
                                path: 'url-venda/adicionar',
                                loadComponent: () =>
                                    import(
                                        './modules/v2/gerador-url-venda/gerador-url-venda-form/gerador-url-venda-form.component'
                                    ).then((m) => m.GeradorUrlVendaFormComponent),
                            },
                            {
                                path: 'link-notificacao',
                                providers: [
                                    ...provideTranslocoScope('postbackLink'),
                                    ...provideTranslocoScope('limits'),
                                ],
                                loadComponent: () =>
                                    import('./modules/links/links-list/links-list.component').then(
                                        (m) => m.LinksListComponent,
                                    ),
                            },
                            {
                                path: 'link-notificacao/adicionar',
                                canActivate: [limitsFeatureGuard(FeatureEnum.POSTBACK_LINK)],
                                providers: [
                                    ...provideTranslocoScope('postbackLink'),
                                    ...provideTranslocoScope('limits'),
                                ],
                                loadComponent: () =>
                                    import('./modules/links/link-add/link-add.component').then(
                                        (m) => m.LinkAddComponent,
                                    ),
                            },
                            {
                                path: 'link-notificacao/:id/editar',
                                providers: [
                                    ...provideTranslocoScope('postbackLink'),
                                    ...provideTranslocoScope('limits'),
                                ],
                                loadComponent: () =>
                                    import('./modules/links/link-add/link-add.component').then(
                                        (m) => m.LinkAddComponent,
                                    ),
                            },
                            {
                                path: 'link-checkout',
                                providers: [
                                    ...provideTranslocoScope('checkoutLink'),
                                    ...provideTranslocoScope('limits'),
                                    ...provideTranslocoScope('shared'),
                                ],
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/list/list.component').then(
                                        (m) => m.ListComponent,
                                    ),
                            },
                            {
                                path: 'link-checkout/adicionar',
                                canActivate: [limitsFeatureGuard(FeatureEnum.CHECKOUT_CONFIGURATION)],
                                providers: [
                                    ...provideTranslocoScope('checkoutLink'),
                                    ...provideTranslocoScope('limits'),
                                    ...provideTranslocoScope('shared'),
                                ],
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/form/form.component').then(
                                        (m) => m.FormComponent,
                                    ),
                            },
                            {
                                path: 'link-checkout/:id/editar',
                                providers: [
                                    ...provideTranslocoScope('checkoutLink'),
                                    ...provideTranslocoScope('limits'),
                                    ...provideTranslocoScope('shared'),
                                ],
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/form/form.component').then(
                                        (m) => m.FormComponent,
                                    ),
                            },

                            {
                                path: 'tag-ratoeira/list',
                                providers: [
                                    ...provideTranslocoScope('tagRatoeira'),
                                    ...provideTranslocoScope('limits'),
                                ],

                                loadComponent: () =>
                                    import(
                                        './modules/tag-ratoeira/components/tag-ratoeira-list/tag-ratoeira-list.component'
                                    ).then((m) => m.TagRatoeiraListComponent),
                            },
                        ],
                    },
                ],
            },
            // Seção Ratoeiras
            {
                path: 'ratoeiras',
                canActivate: [ratoeiraAccessGuard],
                data: { hasBreadcrumbs: true },
                providers: [
                    ...provideTranslocoScope('shieldClick'),
                    ...provideTranslocoScope('limits'),
                    ...provideTranslocoScope('shared'),
                ],
                children: [
                    // Legacy URL `/v2/ratoeiras/ratoeiras…` → flattened `/v2/ratoeiras…`
                    {
                        path: 'ratoeiras',
                        redirectTo: '',
                        pathMatch: 'full',
                    },
                    {
                        path: 'ratoeiras/:id/editar',
                        redirectTo: ':id/editar',
                    },
                    {
                        path: 'ratoeiras/:shieldId/:id/visitas',
                        redirectTo: ':shieldId/:id/visitas',
                    },
                    {
                        path: '',
                        loadComponent: () =>
                            import('./modules/shield-click/shield-click-list/shield-click-list.component').then(
                                (m) => m.ShieldClickListComponent,
                            ),
                    },
                    {
                        path: ':id/editar',
                        canActivate: [ProjetoIdRequiredGuard],
                        loadComponent: () =>
                            import('./modules/shield-click/shield-click-form/shield-click-form.component').then(
                                (m) => m.ShieldClickFormComponent,
                            ),
                    },
                    {
                        path: ':shieldId/:id/visitas',
                        providers: [...provideTranslocoScope('linkVisitaAcesso')],
                        loadComponent: () =>
                            import(
                                './modules/link-visita-acesso/link-visita-acesso-list/link-visita-acesso-list.component'
                            ).then((m) => m.LinkVisitaAcessoListComponent),
                    },
                ],
            },

            // Ratoeira TAG
            {
                path: 'tag-ratoeira/list',
                providers: [...provideTranslocoScope('tagRatoeira'), ...provideTranslocoScope('limits')],

                loadComponent: () =>
                    import('./modules/tag-ratoeira/components/tag-ratoeira-list/tag-ratoeira-list.component').then(
                        (m) => m.TagRatoeiraListComponent,
                    ),
            },
            // IMPORTANTE: a ordem aqui é crítica.
            // O bloco com filhos estáticos (`dados-basicos`, `:tagRatoeiraId/eventos`, ...)
            // precisa vir ANTES de `tag-ratoeira/:tagRatoeiraId`, senão o Angular casa
            // `dados-basicos` como se fosse um `:tagRatoeiraId` e dispara o redirectTo:'overview'.
            {
                path: 'tag-ratoeira/forbidden',
                data: { forbiddenMock: 'tag-ratoeira' },
                providers: [...provideTranslocoScope('planForbidden')],
                loadComponent: () =>
                    import('./modules/v2/dashboard/dashboard-forbidden/dashboard-forbidden.component').then(
                        (m) => m.DashboardForbiddenComponent,
                    ),
            },
            {
                path: 'tag-ratoeira',
                providers: [...provideTranslocoScope('tagRatoeira'), ...provideTranslocoScope('limits')],
                loadComponent: () =>
                    import('./modules/tag-ratoeira/tag-ratoeira-container/tag-ratoeira-container.component').then(
                        (m) => m.tagRatoeiraContainerComponent,
                    ),
                children: [
                    {
                        path: 'new',
                        redirectTo: 'dados-basicos',
                        pathMatch: 'full',
                    },
                    {
                        path: 'tipo-funil',
                        canActivate: [limitsFeatureGuard(FeatureEnum.TOTAL_TAG_RATOEIRA, '/v2/tag-ratoeira/list')],
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/contexts/tipo-funil/tipo-funil-context.component').then(
                                (m) => m.TipoFunilContextComponent,
                            ),
                    },
                    {
                        path: ':tagRatoeiraId/tipo-funil',
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/contexts/tipo-funil/tipo-funil-context.component').then(
                                (m) => m.TipoFunilContextComponent,
                            ),
                    },
                    {
                        path: 'dados-basicos',
                        canActivate: [limitsFeatureGuard(FeatureEnum.TOTAL_TAG_RATOEIRA, '/v2/tag-ratoeira/list')],
                        loadComponent: () =>
                            import(
                                './modules/tag-ratoeira/contexts/dados-basicos/dados-basicos-context.component'
                            ).then((m) => m.DadosBasicosContextComponent),
                    },
                    {
                        path: ':tagRatoeiraId/dados-basicos',
                        loadComponent: () =>
                            import(
                                './modules/tag-ratoeira/contexts/dados-basicos/dados-basicos-context.component'
                            ).then((m) => m.DadosBasicosContextComponent),
                    },
                    {
                        path: ':tagRatoeiraId/modo-ratoeira',
                        loadComponent: () =>
                            import(
                                './modules/tag-ratoeira/contexts/modo-ratoeira/modo-ratoeira-context.component'
                            ).then((m) => m.ModoRatoeiraContextComponent),
                    },
                    {
                        path: ':tagRatoeiraId/eventos',
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/contexts/eventos/eventos-context.component').then(
                                (m) => m.EventosContextComponent,
                            ),
                    },
                    {
                        path: ':tagRatoeiraId/dominios',
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/contexts/dominios/dominios-context.component').then(
                                (m) => m.DominiosContextComponent,
                            ),
                    },
                    {
                        path: ':tagRatoeiraId/configuracoes-avancadas',
                        loadComponent: () =>
                            import(
                                './modules/tag-ratoeira/contexts/configuracoes-avancadas/configuracoes-avancadas-context.component'
                            ).then((m) => m.ConfiguracoesAvancadasContextComponent),
                    },
                ],
            },
            {
                path: 'tag-ratoeira/:tagRatoeiraId',
                providers: [...provideTranslocoScope('tagRatoeira'), ...provideTranslocoScope('limits')],
                loadComponent: () =>
                    import(
                        './modules/tag-ratoeira/components/tag-ratoeira-side-bar/tag-ratoeira-side-bar.component'
                    ).then((m) => m.TagRatoeiraSideBarComponent),
                children: [
                    {
                        path: '',
                        redirectTo: 'overview',
                        pathMatch: 'full',
                    },
                    {
                        path: 'overview',
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/overview/tag-ratoeira-overview.component').then(
                                (m) => m.TagRatoeiraOverviewComponent,
                            ),
                    },
                    {
                        path: 'leads',
                        loadComponent: () =>
                            import('./modules/tag-ratoeira/leads/list/tag-ratoeira-leads-list.component').then(
                                (m) => m.TagRatoeiraLeadsListComponent,
                            ),
                    },
                    {
                        path: 'capi-events',
                        loadComponent: () =>
                            import(
                                './modules/tag-ratoeira/capi-events/list/tag-ratoeira-capi-events-list.component'
                            ).then((m) => m.TagRatoeiraCapiEventsListComponent),
                    },
                ],
            },

            // Seção Notificações
            {
                path: 'notificacoes',
                data: { hasBreadcrumbs: true },
                providers: [
                    ...provideTranslocoScope('postbackLink'),
                    ...provideTranslocoScope('postbackLinkEnvio'),
                    ...provideTranslocoScope('limits'),
                ],
                children: [
                    {
                        path: '',
                        redirectTo: 'link-notificacao',
                        pathMatch: 'full',
                    },
                    {
                        path: 'link-notificacao',
                        children: [
                            {
                                path: '',
                                loadComponent: () =>
                                    import('./modules/links/links-list/links-list.component').then(
                                        (m) => m.LinksListComponent,
                                    ),
                            },
                            {
                                path: 'adicionar',
                                canActivate: [limitsFeatureGuard(FeatureEnum.POSTBACK_LINK)],
                                loadComponent: () =>
                                    import('./modules/links/link-add/link-add.component').then(
                                        (m) => m.LinkAddComponent,
                                    ),
                            },
                            {
                                path: ':id/editar',
                                loadComponent: () =>
                                    import('./modules/links/link-add/link-add.component').then(
                                        (m) => m.LinkAddComponent,
                                    ),
                            },
                        ],
                    },
                    {
                        path: 'logs',
                        canActivate: [staffSessionGuard],
                        data: { backupType: LogsBackupType.NOTIFICATION },
                        loadComponent: () =>
                            import('./modules/logs-backup/logs-backup-page.component').then(
                                (m) => m.LogsBackupPageComponent,
                            ),
                    },
                    {
                        path: 'vendas/integracao',
                        canActivate: [ListagemVendaGuard],
                        children: [
                            {
                                path: '',
                                canActivate: [RedeAdsQueryParamAtivaGuard],
                                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                                loadComponent: () =>
                                    import(
                                        './modules/postback-link-envio/notification-dashboard/notification-dashboard.component'
                                    ).then((m) => m.NotificationDashboardComponent),
                            },
                            {
                                path: 'legado',
                                loadComponent: () =>
                                    import(
                                        './modules/postback-link-envio/listagem-vendas-integracao/listagem-vendas-integracao.component'
                                    ).then((m) => m.ListagemVendasIntegracaoComponent),
                            },
                        ],
                    },
                ],
            },
            // Seção Checkout
            {
                path: 'checkout',
                data: { hasBreadcrumbs: true },
                providers: [
                    ...provideTranslocoScope('checkoutLink'),
                    ...provideTranslocoScope('limits'),
                    ...provideTranslocoScope('shared'),
                ],
                children: [
                    {
                        path: '',
                        redirectTo: 'link-checkout',
                        pathMatch: 'full',
                    },
                    {
                        path: 'link-checkout',
                        children: [
                            {
                                path: '',
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/list/list.component').then(
                                        (m) => m.ListComponent,
                                    ),
                            },
                            {
                                path: 'adicionar',
                                canActivate: [limitsFeatureGuard(FeatureEnum.CHECKOUT_CONFIGURATION)],
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/form/form.component').then(
                                        (m) => m.FormComponent,
                                    ),
                            },
                            {
                                path: ':id/editar',
                                loadComponent: () =>
                                    import('./modules/checkout/checkout-configuration/form/form.component').then(
                                        (m) => m.FormComponent,
                                    ),
                            },
                            {
                                path: ':id/checkouts',
                                loadComponent: () =>
                                    import(
                                        './modules/checkout/checkout-configuration/get-all-checkouts/get-all-checkouts.component'
                                    ).then((m) => m.GetAllCheckoutsComponent),
                            },
                        ],
                    },
                    {
                        path: 'logs',
                        canActivate: [staffSessionGuard],
                        data: { backupType: LogsBackupType.CHECKOUT },
                        loadComponent: () =>
                            import('./modules/logs-backup/logs-backup-page.component').then(
                                (m) => m.LogsBackupPageComponent,
                            ),
                    },
                    {
                        path: 'lista-checkouts',
                        canActivate: [RedeAdsQueryParamAtivaGuard],
                        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                        loadComponent: () =>
                            import('./modules/checkout/checkout-dashboard/checkout-dashboard.component').then(
                                (m) => m.CheckoutDashboardComponent,
                            ),
                    },
                ],
            },
            // Taxas
            {
                path: 'fees',
                canActivate: [minimumPlanBlockedGuard],
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('fee')],
                children: [
                    {
                        path: '',
                        canActivate: [],
                        loadComponent: () =>
                            import('./modules/fee/components/list/list.component').then((m) => m.ListComponent),
                    },
                    {
                        path: 'add',
                        loadComponent: () =>
                            import('./modules/fee/components/add/add.component').then((m) => m.AddComponent),
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () =>
                            import('./modules/fee/components/add/add.component').then((m) => m.AddComponent),
                    },
                ],
            },
            // Taxas
            // Impostos
            {
                path: 'taxes',
                canActivate: [minimumPlanBlockedGuard],
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('taxes')],
                children: [
                    {
                        path: '',
                        canActivate: [],
                        loadComponent: () =>
                            import('./modules/taxes/tax-list/tax-list.component').then((m) => m.TaxListComponent),
                    },
                    {
                        path: 'add',
                        loadComponent: () =>
                            import('./modules/taxes/components/add-new-tax/add-new-tax.component').then(
                                (m) => m.AddNewTaxComponent,
                            ),
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () =>
                            import('./modules/taxes/components/add-new-tax/add-new-tax.component').then(
                                (m) => m.AddNewTaxComponent,
                            ),
                    },
                ],
            },
            // Impostos
            // Produtos
            {
                path: 'products',
                canActivate: [minimumPlanBlockedGuard],
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('products')],
                children: [
                    {
                        path: '',
                        canActivate: [],
                        loadComponent: () =>
                            import('./modules/products/components/list/list.component').then((m) => m.ListComponent),
                    },
                    {
                        path: 'add',
                        loadComponent: () =>
                            import('./modules/products/components/add/add.component').then((m) => m.AddComponent),
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () =>
                            import('./modules/products/components/add/add.component').then((m) => m.AddComponent),
                    },
                ],
            },
            // Produtos
            // Link Visita
            {
                path: 'link-visita',
                canActivate: [ratoeiraAccessGuard],
                data: { hasBreadcrumbs: true },
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './modules/link-visita-configuration/link-visita-configuration-list/link-visita-configuration-list.component'
                            ).then((m) => m.LinkVisitaConfigurationListComponent),
                    },
                    {
                        path: 'adicionar',
                        loadComponent: () =>
                            import(
                                './modules/link-visita-configuration/link-visita-configuration-form/link-visita-configuration-form.component'
                            ).then((m) => m.LinkVisitaConfigurationFormComponent),
                    },
                    {
                        path: ':id/editar',
                        loadComponent: () =>
                            import(
                                './modules/link-visita-configuration/link-visita-configuration-form/link-visita-configuration-form.component'
                            ).then((m) => m.LinkVisitaConfigurationFormComponent),
                    },
                    {
                        path: ':id/visitas',
                        providers: [...provideTranslocoScope('linkVisitaAcesso')],
                        loadComponent: () =>
                            import(
                                './modules/link-visita-acesso/link-visita-acesso-list/link-visita-acesso-list.component'
                            ).then((m) => m.LinkVisitaAcessoListComponent),
                    },
                ],
            },

            {
                path: 'whatsapp',
                canActivate: [whatsappModuleGuard],
                providers: [...provideTranslocoScope('whatsapp')],
                loadComponent: () =>
                    import('./modules/whatsapp/whatsapp-shell.component').then((m) => m.WhatsappShellComponent),
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./modules/whatsapp/inbox/whatsapp-inbox.component').then(
                                (m) => m.WhatsappInboxComponent,
                            ),
                    },
                    {
                        path: 'funil',
                        loadComponent: () =>
                            import('./modules/whatsapp/funil/whatsapp-funil.component').then(
                                (m) => m.WhatsappFunilComponent,
                            ),
                    },
                    {
                        path: 'etapas',
                        loadComponent: () =>
                            import('./modules/whatsapp/etapas/whatsapp-etapas.component').then(
                                (m) => m.WhatsappEtapasComponent,
                            ),
                    },
                ],
            },
            {
                path: 'integrations/account-center',
                canActivateChild: [RedeAdsAtivaGuard],
                data: {
                    hasBreadcrumbs: true,
                },
                children: [
                    {
                        path: '',
                        providers: [...provideTranslocoScope('redeAds'), ...provideTranslocoScope('whatsapp')],
                        loadComponent: () =>
                            import('./modules/account-center/rede-ads-list/rede-ads-list.component').then(
                                (m) => m.RedeAdsListComponent,
                            ),
                    },
                    {
                        path: 'whatsapp',
                        canActivate: [whatsappModuleGuard],
                        providers: [...provideTranslocoScope('whatsapp')],
                        loadComponent: () =>
                            import('./modules/whatsapp/numeros/whatsapp-numeros.component').then(
                                (m) => m.WhatsappNumerosComponent,
                            ),
                    },
                    {
                        path: 'google-ads-profile-list',
                        data: { network: RedeAdsEnum.GOOGLE_ADS },
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/profile-list/profile-list.component').then(
                                (m) => m.ProfileListComponent,
                            ),
                    },
                    {
                        path: 'meta-ads-profile-list',
                        data: { network: RedeAdsEnum.META_ADS },
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/profile-list/profile-list.component').then(
                                (m) => m.ProfileListComponent,
                            ),
                    },
                    {
                        path: 'newsbreak-ads-profile-list',
                        data: { network: RedeAdsEnum.NEWSBREAK },
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/profile-list/profile-list.component').then(
                                (m) => m.ProfileListComponent,
                            ),
                    },
                    {
                        path: 'newsbreak-ads-profile/:profileId/organizations',
                        data: { network: RedeAdsEnum.NEWSBREAK, level: 'organizations' },
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/profile-list/profile-list.component').then(
                                (m) => m.ProfileListComponent,
                            ),
                    },
                    {
                        path: 'newsbreak-ads-profile/:profileId/organizations/:organizationId/accounts',
                        data: { network: RedeAdsEnum.NEWSBREAK },
                        providers: [...provideTranslocoScope('redeAds'), ...provideTranslocoScope('limits')],
                        loadComponent: () =>
                            import(
                                './modules/account-center/rede-ads-account-list/rede-ads-account-list.component'
                            ).then((m) => m.RedeAdsAccountListComponent),
                    },
                    {
                        path: 'taboola-ads-profile-list',
                        data: { network: RedeAdsEnum.TABOOLA },
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/profile-list/profile-list.component').then(
                                (m) => m.ProfileListComponent,
                            ),
                    },
                    {
                        path: 'taboola-ads-profile/:profileId/accounts',
                        data: { network: RedeAdsEnum.TABOOLA },
                        providers: [...provideTranslocoScope('redeAds'), ...provideTranslocoScope('limits')],
                        loadComponent: () =>
                            import(
                                './modules/account-center/rede-ads-account-list/rede-ads-account-list.component'
                            ).then((m) => m.RedeAdsAccountListComponent),
                    },
                    {
                        path: 'google-ads-profile/:profileId/accounts',
                        data: { network: RedeAdsEnum.GOOGLE_ADS },
                        providers: [...provideTranslocoScope('redeAds'), ...provideTranslocoScope('limits')],
                        loadComponent: () =>
                            import(
                                './modules/account-center/rede-ads-account-list/rede-ads-account-list.component'
                            ).then((m) => m.RedeAdsAccountListComponent),
                    },
                    {
                        path: 'meta-ads-profile/:profileId/accounts',
                        data: { network: RedeAdsEnum.META_ADS },
                        providers: [...provideTranslocoScope('redeAds'), ...provideTranslocoScope('limits')],
                        loadComponent: () =>
                            import(
                                './modules/account-center/rede-ads-account-list/rede-ads-account-list.component'
                            ).then((m) => m.RedeAdsAccountListComponent),
                    },
                ],
            },
            {
                path: 'integrations/vturb',
                providers: [...provideTranslocoScope('vturb')],
                loadComponent: () =>
                    import('./modules/vturb/integration/integration.component').then((m) => m.IntegrationComponent),
            },
            {
                path: 'integrations',
                data: { hasBreadcrumbs: true },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: '/v2/integrations/account-center',
                    },
                    {
                        path: 'fontes-trafego',
                        canActivate: [fontesTrafegoGuard],
                        providers: [...provideTranslocoScope('fontesTrafego')],
                        loadComponent: () =>
                            import('./modules/fontes-trafego/fontes-trafego-page/fontes-trafego-page.component').then(
                                (m) => m.FontesTrafegoPageComponent,
                            ),
                    },
                ],
            },
            {
                path: 'rede-ads-indisponivel',
                providers: [...provideTranslocoScope('redeAdsIndisponivel')],
                loadComponent: () =>
                    import('./modules/rede-ads-indisponivel/rede-ads-indisponivel.component').then(
                        (m) => m.RedeAdsIndisponivelComponent,
                    ),
            },
            {
                path: 'integrations/vturb/main-dashboard',
                redirectTo: '/v2/integrations/vturb/analytics',
                pathMatch: 'full',
            },
            {
                path: 'integrations/vturb/analytics',
                providers: [...provideTranslocoScope('vturb')],
                loadComponent: () =>
                    import('./modules/vturb/main-dashboard/main-dashboard.component').then(
                        (m) => m.VturbAnalyticsDashboardComponent,
                    ),
            },
            {
                path: 'integrations/vturb/segmentation-retention',
                providers: [...provideTranslocoScope('vturb')],
                loadComponent: () =>
                    import('./modules/vturb/vturb-segmentation-retention/vturb-segmentation-retention.component').then(
                        (m) => m.VturbSegmentationRetentionComponent,
                    ),
            },

            // Integrações
            {
                path: 'integracoes',
                children: [
                    {
                        path: '',
                        redirectTo: 'choose-rede-ads',
                        pathMatch: 'full',
                    },
                    {
                        path: 'choose-rede-ads',
                        providers: [...provideTranslocoScope('redeAds')],
                        loadComponent: () =>
                            import('./modules/account-center/rede-ads-list/rede-ads-list.component').then(
                                (m) => m.RedeAdsListComponent,
                            ),
                    },
                    {
                        path: 'perfis-google',
                        loadComponent: () =>
                            import(
                                './modules/integracoes/google-ads/google-profile/google-profile-lista/google-profile-lista.component'
                            ).then((m) => m.GoogleProfileListaComponent),
                    },
                    {
                        path: 'perfis-google/:id/detalhes',
                        loadComponent: () =>
                            import(
                                './modules/integracoes/google-ads/google-profile/google-profile-painel/google-profile-painel.component'
                            ).then((m) => m.GoogleProfilePainelComponent),
                        children: [
                            {
                                path: 'configuracao-conversao',
                                loadComponent: () =>
                                    import(
                                        './modules/integracoes/google-ads/google-profile/configuracao-conversao/google-configucarao-conversao/google-configucarao-conversao.component'
                                    ).then((m) => m.GoogleConfigucaraoConversaoComponent),
                            },
                        ],
                    },

                    {
                        path: 'apikey',
                        data: { hasBreadcrumbs: true },
                        providers: [...provideTranslocoScope('apiKey'), ...provideTranslocoScope('shared')],
                        children: [
                            {
                                path: '',
                                loadComponent: () =>
                                    import('./modules/api-key/list/api-key-list.component').then(
                                        (m) => m.ApikeyListComponent,
                                    ),
                            },
                            {
                                path: 'adicionar',
                                loadComponent: () =>
                                    import('./modules/api-key/form/api-key-form.component').then(
                                        (m) => m.ApiKeyFormComponent,
                                    ),
                            },
                            {
                                path: ':id/editar',
                                loadComponent: () =>
                                    import('./modules/api-key/form/api-key-form.component').then(
                                        (m) => m.ApiKeyFormComponent,
                                    ),
                            },
                        ],
                    },
                ],
            },
            // Relatórios - Início
            {
                path: 'relatorios',
                canActivate: [ratoeiraAccessGuard, minimumPlanBlockedGuard],
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('report'), ...provideTranslocoScope('shared')],
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./modules/report/dashboard/dashboard.component').then((m) => m.DashboardComponent),
                    },
                    {
                        path: 'funil-topo',
                        loadComponent: () =>
                            import('./modules/report/funil/rel-funil-topo/rel-funil-topo.component').then(
                                (m) => m.RelFunilTopoComponent,
                            ),
                    },
                    {
                        path: 'rato-por-ratoeira',
                        loadComponent: () =>
                            import('./modules/report/rato-por-ratoeira/rato-por-ratoeira.component').then(
                                (m) => m.RatoPorRatoeiraComponent,
                            ),
                    },
                    {
                        path: 'checkout-por-ratoeira',
                        loadComponent: () =>
                            import('./modules/report/checkout-por-ratoeira/checkout-por-ratoeira.component').then(
                                (m) => m.CheckoutPorRatoeiraComponent,
                            ),
                    },
                    {
                        path: 'biblioteca-de-ratos',
                        loadComponent: () =>
                            import('./modules/report/biblioteca-ratos/biblioteca-ratos.component').then(
                                (m) => m.BibliotecaRatosComponent,
                            ),
                    },
                ],
            },
            // Relatórios - Fim
            // Domínios Próprios
            {
                path: 'dominios',
                canActivate: [ratoeiraAccessGuard],
                data: { hasBreadcrumbs: true },
                providers: [...provideTranslocoScope('dominios'), ...provideTranslocoScope('shared')],
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./modules/cliente-dominio/list/list.component').then((m) => m.ListComponent),
                    },
                    {
                        path: 'adicionar',
                        loadComponent: () =>
                            import('./modules/cliente-dominio/form/form.component').then((m) => m.FormComponent),
                    },
                    {
                        path: ':id/editar',
                        loadComponent: () =>
                            import('./modules/cliente-dominio/form/form.component').then((m) => m.FormComponent),
                    },
                ],
            },
            // URL Produtor
            {
                path: 'url-produtor',
                data: { hasBreadcrumbs: true },
                providers: [
                    ...provideTranslocoScope('urlProdutor'),
                    ...provideTranslocoScope('shared'),
                    ...provideTranslocoScope('limits'),
                ],
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./modules/url-produtor/url-produtor-list/url-produtor-list.component').then(
                                (m) => m.UrlProdutorListComponent,
                            ),
                    },
                    {
                        path: 'adicionar',
                        loadComponent: () =>
                            import('./modules/url-produtor/url-produtor-form/url-produtor-form.component').then(
                                (m) => m.UrlProdutorFormComponent,
                            ),
                    },
                    {
                        path: ':id/editar',
                        loadComponent: () =>
                            import('./modules/url-produtor/url-produtor-form/url-produtor-form.component').then(
                                (m) => m.UrlProdutorFormComponent,
                            ),
                    },
                ],
            },
            // Campaign Creator — Google Ads Search
            {
                path: 'campaign-creator/forbidden',
                data: { forbiddenMock: 'campaign-creator' },
                providers: [...provideTranslocoScope('planForbidden')],
                loadComponent: () =>
                    import('./modules/v2/dashboard/dashboard-forbidden/dashboard-forbidden.component').then(
                        (m) => m.DashboardForbiddenComponent,
                    ),
            },
            {
                path: 'campaign-creator/google-ads/search/wizard',
                canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                data: {
                    network: RedeAdsEnum.GOOGLE_ADS,
                },
                providers: [...provideTranslocoScope('campaignCreator')],
                loadComponent: () =>
                    import('./modules/campaign-creator/google-ads/search/wizard/wizard.component').then(
                        (m) => m.WizardComponent,
                    ),
            },
            {
                path: 'campaign-creator/google-ads/search/preview',
                canActivate: [minimumPlanBlockedGuard, RedeAdsAtivaGuard],
                data: {
                    network: RedeAdsEnum.GOOGLE_ADS,
                },
                providers: [...provideTranslocoScope('campaignCreator')],
                loadComponent: () =>
                    import('./modules/campaign-creator/google-ads/search/preview/preview.component').then(
                        (m) => m.PreviewComponent,
                    ),
            },
            // Gerador URL Campanha (Produtor) - V2
            {
                path: 'gerador-url-campanha',
                providers: [
                    ...provideTranslocoScope('limits'),
                    ...provideTranslocoScope('geradorUrl'),
                    ...provideTranslocoScope('shared'),
                ],
                children: [
                    {
                        path: 'produtor',
                        loadComponent: () =>
                            import(
                                './modules/gerador-url/gerador-url-campanha-produtor/gerador-url-campanha-produtor.component'
                            ).then((m) => m.GeradorUrlCampanhaProdutorComponent),
                    },
                    {
                        path: 'produtor/v1',
                        loadComponent: () =>
                            import(
                                './modules/gerador-url/gerador-url-campanha-simples/gerador-url-campanha-simples.component'
                            ).then((m) => m.GeradorUrlCampanhaSimplesComponent),
                    },
                ],
            },
            // URL de venda
            {
                path: 'url-venda',
                loadComponent: () =>
                    import(
                        './modules/gerador-url/gerador-url-campanha-presell-parametro-valor/gerador-url-campanha-presell-parametro-valor.component'
                    ).then((m) => m.GeradorUrlCampanhaPresellParametroValorComponent),
            },
        ],
    },
    // Rotas externas (sem login) - Multilogin OAuth
    {
        path: 'conect-google-ads-profile',
        data: { platform: 'google-ads' },
        providers: [...provideTranslocoScope('redeAds')],
        loadComponent: () =>
            import('./modules/account-center/rede-ads-multi-login/rede-ads-multi-login.component').then(
                (m) => m.RedeAdsMultiLoginComponent,
            ),
    },
    {
        path: 'conect-meta-ads-profile',
        data: { platform: 'meta-ads' },
        providers: [...provideTranslocoScope('redeAds')],
        loadComponent: () =>
            import('./modules/account-center/rede-ads-multi-login/rede-ads-multi-login.component').then(
                (m) => m.RedeAdsMultiLoginComponent,
            ),
    },
    {
        path: 'conect-google-ads-profile-success',
        data: { platform: 'google-ads' },
        providers: [...provideTranslocoScope('redeAds')],
        loadComponent: () =>
            import('./modules/account-center/rede-ads-multi-login-success/rede-ads-multi-login-success.component').then(
                (m) => m.RedeAdsMultiLoginSuccessComponent,
            ),
    },
    {
        path: 'conect-meta-ads-profile-success',
        data: { platform: 'meta-ads' },
        providers: [...provideTranslocoScope('redeAds')],
        loadComponent: () =>
            import('./modules/account-center/rede-ads-multi-login-success/rede-ads-multi-login-success.component').then(
                (m) => m.RedeAdsMultiLoginSuccessComponent,
            ),
    },
    {
        path: 'integrations/vturb',
        redirectTo: 'v2/integrations/vturb',
        pathMatch: 'full',
    },
    // Redirecionamentos para V2
    {
        path: '',
        redirectTo: 'v2',
        pathMatch: 'full',
    },
];
